import apiClient from './client'

export interface FlightConnection {
  departure_airport: string
  departure_city: string
  arrival_airport: string
  arrival_city: string
  departure_time: string
  arrival_time: string
  departure_terminal: string
  arrival_terminal: string
}

export interface FlightInfo {
  found: true
  airline: string
  flight_number: string
  departure_airport: string
  departure_city: string
  arrival_airport: string
  arrival_city: string
  departure_time: string
  arrival_time: string
  departure_terminal: string
  arrival_terminal: string
  /** 同機號當天接續的其他航段（例如轉機接續下一段），沒有的話是空陣列 */
  connections?: FlightConnection[]
}

export interface FlightNotFound {
  found: false
  message: string
}

export type FlightLookupResult = FlightInfo | FlightNotFound

export async function lookupFlight(flight: string, date: string): Promise<FlightLookupResult> {
  const { data } = await apiClient.get('/flights/lookup', {
    params: { flight, date },
  })
  return data
}
